module.exports = __webpack_public_path__ + "static/media/gallery-1.a557b893.jpg";